import React, { useState, useEffect } from 'react';
import axios from 'axios';
import QRCode from 'react-qr-code';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Dialog,
  DialogContent
} from '@mui/material';

const FriendCodes = () => {
  const [friendcode, setFriendcode] = useState('');
  const [friendcodes, setFriendcodes] = useState([]);
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCode, setSelectedCode] = useState('');

  const fetchFriendcodes = async () => {
    try {
      const response = await axios.get('/api/global/friendcodes');
      setFriendcodes(response.data);
    } catch (err) {
      console.error('Fehler beim Laden der Freundescodes:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post('/api/global/friendcodes', { friendcode });
      setFriendcode('');
      fetchFriendcodes();
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setError('Der Code existiert bereits. Derselbe Code kann erst nach 24 Stunden erneut eingereicht werden.');
      } else {
        console.error('Fehler beim Absenden des Freundescodes:', err);
        setError('Beim Absenden des Codes ist ein Fehler aufgetreten');
      }
    }
  };

  useEffect(() => {
    fetchFriendcodes();
  }, []);

  const handleQrClick = (code) => {
    setSelectedCode(code);
    setOpenDialog(true);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Freundescode einreichen
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        Öffentliche Freundescodes werden nach 24 Stunden automatisch gelöscht. Erst danach kann derselbe Code erneut eingereicht werden.
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Freundescode"
          fullWidth
          value={friendcode}
          onChange={(e) => setFriendcode(e.target.value)}
          placeholder="z. B. 1234-5678-9012"
        />
        <Button type="submit" variant="contained">
          Absenden
        </Button>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <List>
        {friendcodes.map((code) => (
          <React.Fragment key={code.id}>
            <ListItem alignItems="flex-start" button onClick={() => handleQrClick(code.friendcodes)}>
              <ListItemAvatar>
                <Avatar variant="square" sx={{ bgcolor: 'white', p: 1 }}>
                  <QRCode value={code.friendcodes.toString()} size={48} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={code.friendcodes}
                secondary={`Hinzugefügt am: ${new Date(code.insert_time).toLocaleString()}`}
              />
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
      </List>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogContent>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
            <QRCode value={selectedCode} size={256} />
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default FriendCodes;
